import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import moment from 'moment';

import { 
  loadStores,
  removeStore,
} from '../../reducers/stores';

import './Stores.css';

class Stores extends Component {

  componentDidMount = () => {
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps = () => {
  }

  getCategory = (categoryId) => {
    return this.props.categories.find((category) => {
      return category.category_id === categoryId;
    });
  }

  removeStore = (store) => {
    if(window.confirm(`Do you want to remove ${store.store_name}?`)){
      this.props.removeStore(store.id);
    }
  }

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Point of Interests</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">

              <div className="input-group col-md-4">
                {/* <input type="text" className="form-control" aria-label="Text input with dropdown button" placeholder="Search Stores" /> */}
                {/* <div className="input-group-append">
                  <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">All Stores</button>
                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="">Categories</a>
                    <a className="dropdown-item" href="">Tags</a>
                    <div role="separator" className="dropdown-divider"></div>
                    <a className="dropdown-item" href="">All Stores</a>
                  </div>
                </div> */}
              </div>

              <div className="col-md-4 offset-md-4">
                <Link to="/pointofinterests/add" className="btn btn-primary float-right">Add Point of Interest</Link>
              </div>

            </div>
            
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Point of Interest</th>
                  <th scope="col">Category</th>
                  <th scope="col">Date Created</th>
                  <th scope="col" width="200">Actions</th>
                </tr>
              </thead>
              {this.props.isLoadingStores &&
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center"><em>Loading Point of Interests</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingStores && this.props.stores.length === 0 &&
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center"><em>0 Point of Interests</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingStores && this.props.stores && this.props.categories &&
                <tbody>
                  {this.props.stores.map((store, idx) => {
                    return (
                      <tr key={`store-${idx}`}>
                        <th>{store.store_name}</th>
                        <td>
                          {store.store_category.map((category, idx) => {
                            return (<span className={`store-category-item badge badge-light`} key={`${store.id}-${category.category_id}`}>{category.category_name}</span>);
                          })}
                        </td>
                        <td>{moment(store.date_created).fromNow()}</td>
                        <td>
                          <Link to={`/pointofinterests/${store.store_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                          <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeStore(store)}>Remove</button>&nbsp;
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              }
            </table>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  stores: state.stores.stores,
  isLoadingStores: state.stores.isLoadingStores,
  categories: state.categories.categories
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadStores,
      removeStore
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Stores);


// WEBPACK FOOTER //
// ./src/modules/Stores/Stores.js